import * as React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import PollResults from '../../../shared/components/PollResults';
import QuizResults from '../../../shared/components/QuizResults';
import t from '../../../shared/translations';
import Modal from '../../components/Modal';
import { Dispatch, openModal } from '../../state';
import NavTabs from '../NavTabs';
import { IPollAnswerSet, IQuizAnswerSet, ISubmittedTask } from '../query';
import Download from './Download';
import GroupedAnswers from './GroupedAnswers';
import UngroupedAnswers from './UngroupedAnswers';

interface IProps {
    task: ISubmittedTask;
}

const Row = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    @media (min-width: 768px) {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
`;

// Supported answer types: textbox, checkbox, quiz, file

function AllAnswers({ task }: IProps): JSX.Element {
    const dispatch = useDispatch<Dispatch>();
    const [grouped, setGrouped] = React.useState(false);
    const [modalQuizResult, setModalQuizResullt] = React.useState<IQuizAnswerSet>(null);
    const [modalPollResult, setModalPollResullt] = React.useState<IPollAnswerSet>(null);

    const openQuizResults = (quizResult: IQuizAnswerSet) => {
        setModalQuizResullt(quizResult);
        dispatch(openModal('SubmittedTask/QuizResults'));
    }

    const openPollResults = (pollResult: IPollAnswerSet) => {
        setModalPollResullt(pollResult);
        dispatch(openModal('SubmittedTask/PollResults'));
    }

    let main = null;
    if (grouped) {
        main = <GroupedAnswers
            sharedAnswers={task.sharedAnswers}
            openQuizResults={openQuizResults}
            openPollResults={openPollResults}
        />;
    } else {
        main = <UngroupedAnswers
            sharedAnswers={task.sharedAnswers}
            openQuizResults={openQuizResults}
            openPollResults={openPollResults}
        />;
    }
    return <>
        <h1>{task.shortTitle}</h1>
        <NavTabs task={task} />
        <Row>
            <label>
                <input type='checkbox' checked={grouped} onChange={e => setGrouped(e.currentTarget.checked)} />
                {' '}{t('player.submitted-task.label-all-answers-grouped')}
            </label>
            <Download grouped={grouped} taskId={task.id} />
        </Row>
        {main}
        <Modal modal='SubmittedTask/QuizResults'>
            <h4>{t('player.submitted-task.heading-quiz-results')}</h4>
            <QuizResults results={modalQuizResult?.answers} />
        </Modal>
        <Modal modal='SubmittedTask/PollResults'>
            <h4>{t('player.submitted-task.heading-poll-results')}</h4>
            <PollResults answers={modalPollResult?.answers} />
        </Modal>
    </>;
}

export default AllAnswers;
